import { render, staticRenderFns } from "./forgetPass.vue?vue&type=template&id=aae9b1cc&scoped=true"
import script from "./forgetPass.vue?vue&type=script&lang=js"
export * from "./forgetPass.vue?vue&type=script&lang=js"
import style0 from "./forgetPass.vue?vue&type=style&index=0&id=aae9b1cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae9b1cc",
  null
  
)

export default component.exports